<template>
  <div class="operation-process1" ref="process">
    <div class="bg" v-if="!isMobile"></div>
    <h3 class="description">核心企业确权模式</h3>
    <el-row :gutter="20" class="process">
      <el-col
        :xs="24"
        :sm="24"
        :md="8"
        :lg="8"
        :xl="8"
        class="process-item"
        :class="{ active: current === index }"
        v-for="(item, index) in process"
        :key="index"
        @mouseenter.native="mouseEnter(index)"
        @mouseleave.native="mouseLeave"
      >
        <div class="header">
          <p class="step">0{{ index + 1 }}</p>
          <div class="text">
            <h4 class="main-title">{{ item.title }}</h4>
            <p class="sub-title">{{ item.subTitle }}</p>
          </div>
        </div>

        <div class="content">
          <p class="text" v-for="(text, i) in item.content" :key="i">
            <span class="icon">+</span>
            <span>{{ text }}</span>
          </p>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>

import mixin from "./mixin";

export default {
  mixins: [mixin],
  data() {
    return {
      process: [
        {
          title: "创建订单",
          subTitle: "create order",
          content: ["创建订单"]
        },
        {
          title: "上传凭证",
          subTitle: "upload voucher",
          content: ["贸易合同", "交易发票", "确权书"]
        },
        {
          title: "收款设置",
          subTitle: "collection settings",
          content: ["提交订单", "选择收款银行", "签订保理合同", "收款"]
        }
      ]
    };
  },
  methods: {
    setTweenLite(left) {
      this.tl
        .to(".operation-process1 .bg", 0.3, {
          immediateRender: true,
          left
        });
    },
  }
};
</script>

<style lang="scss">
  @import "./style.scss";
</style>